import { render, staticRenderFns } from "./ControlTab.vue?vue&type=template&id=62ea09f7&"
import script from "./ControlTab.vue?vue&type=script&lang=js&"
export * from "./ControlTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports